import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { TicketSystemComponent } from 'src/app/components/ticket/ticket-system/ticket-system.component';
import { DeployParams } from 'src/app/deployParams';
import { TicketPlayType, TypeOfPlaceBetTicket } from 'src/app/models/enums';
import { ConstantValues } from 'src/app/models/util/constantValues';

@Component({
  selector: 'app-ticket-system-mobile',
  templateUrl: './ticket-system-mobile.component.html',
  styleUrls: ['./ticket-system-mobile.component.less']
})



export class TicketSystemMobileComponent extends TicketSystemComponent implements AfterViewInit, OnInit {
  @Input()
  set bankersChanged(a: boolean) {
    this.showSystemOptions = true;
  }
  public showPayoutInfos = false;
  public ticketPlayTypeEnum = TicketPlayType;

  placeBetTypeEnum = TypeOfPlaceBetTicket;


  showHideSystemOptions() {
    this.showSystemOptions = !this.showSystemOptions;
  }

  ngOnInit() {
    if (this.isUserLoggedIn) {
      this.placeBetType = TypeOfPlaceBetTicket.Standard;
    } else {
      this.placeBetType = TypeOfPlaceBetTicket.Express;
    }
    console.log(ConstantValues.PREDEFINED_DENOMINATIONS);
    console.log(this.placeBetType);
  }

  setDenomination(denomination: number) {
    if (denomination) {
      this.payin = denomination.toString();
    }
  }

  ngAfterViewInit(): void {
    if (this.bankerTicketItemGroups.length < 1) {
      this.showSystemOptions = false;
    }
  }
}

